module.exports = __webpack_public_path__ + "static/img/07.499c21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/07.png
// module id = bHdY
// module chunks = 1